<div class="taglist">
    <ng-template ngFor let-tag [ngForOf]="inputTagList">
        <terra-tag
            [tagId]="tag.id"
            [name]="tag.name"
            [inputIsTaggable]="tag.isTaggable"
            [inputIsTagged]="tag.isTagged"
            [inputCustomClass]="tag.customClass"
            [inputColor]="tag.color"
            [isClosable]="tag.isClosable && !isReadOnly"
            [names]="tag.names"
            (closeTag)="closeTag.emit($event)"
        >
        </terra-tag>
    </ng-template>
</div>
